import React from 'react';

const UserManagementIcon = () => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M6.66927 10H4.0026C3.29536 10 2.61708 10.281 2.11699 10.781C1.61689 11.2811 1.33594 11.9594 1.33594 12.6667V14M9.53927 11.02L10.1546 10.7653M10.1546 9.23467L9.53927 8.97933M11.2373 8.152L10.9819 7.53667M11.2373 11.848L10.9819 12.464M12.7679 8.152L13.0233 7.53667M13.0226 12.464L12.7679 11.848M13.8506 9.23467L14.4666 8.97933M13.8506 10.7653L14.4666 11.0207M14.0026 10C14.0026 11.1046 13.1072 12 12.0026 12C10.898 12 10.0026 11.1046 10.0026 10C10.0026 8.89543 10.898 8 12.0026 8C13.1072 8 14.0026 8.89543 14.0026 10ZM8.66927 4.66667C8.66927 6.13943 7.47536 7.33333 6.0026 7.33333C4.52984 7.33333 3.33594 6.13943 3.33594 4.66667C3.33594 3.19391 4.52984 2 6.0026 2C7.47536 2 8.66927 3.19391 8.66927 4.66667Z'
        stroke='#232222'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default UserManagementIcon;
